// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"a2-z","categoryName":"b2-z","categoryImage":"c2-z","categoryContent":"d2-z","bottomAligned":"e2-z"};